import React from 'react';
import { Routes, Route } from "react-router-dom";
import ListingList from "./listing-list/listing-list";
import ListingDetails from "./listing-details/listing-details";
import ListingApplication from "./listing-application/listing-application";

const Listing = () => {
  return (
    <Routes>
      <Route index element={<ListingList />} />
      <Route path="application/:applicationId" element={<ListingApplication />} />
      <Route path="application/" element={<ListingApplication />} />
      <Route path=":applicationId" element={<ListingDetails />} />
    </Routes>
  )
}

export default Listing;



